import HTTP from '@/utils/http'
/**
 * 
 * @param {*} params 
 */

// 获取分类 
export const getCateList = (params) => HTTP("/api/v2/cate/cateList",params,false,)

// 获取部门列表
export const getAreaList = (params) => HTTP("/api/v2/area/areaList",params,false,)

// 事件上报
export const postEvent = (params) => HTTP("/api/v2/event/post",params,false,)

// 存档派单
export const sendOrder = (params) => HTTP("api/v2/event/appoint",params,false,)

// 责任部门列表
export const getDepartmentList = (params) => HTTP("api/v2/cate/categoryInfo",params,false,)